/* eslint-env browser */
/* eslint-disable react/jsx-no-target-blank */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { push } from 'redux-router';
import has from 'lodash/has';
import findIndex from 'lodash/findIndex';
import isObject from 'lodash/isObject';
import each from 'lodash/each';
import includes from 'lodash/includes';
import moment from 'moment';
import auth from 'lib/Auth';
import Calendar from 'lib/Calendar';

import { loadEvent, apiFetch, API_ROOT, setFlashMessage, removeFlashMessage } from 'actions';

import Loading from 'components/common/Loading';
import Icon from 'components/common/Icon';
import ActionButtonRow from 'components/inbox/ActionButtonRow';
import OverrideConflicts from 'components/inbox/OverrideConflicts';
import Collapsable from 'components/calendar/Collapsable';
import EventBubble from 'components/calendar/EventBubble';

class EventDetails extends Component {
  get setupInstructions() {
    return { __html: this.props.event.setup_instructions };
  }

  get description() {
    return { __html: this.props.event.description };
  }

  get notes() {
    return { __html: this.props.event.notes };
  }

  transportationRequestTime(requestTime) {

    const dateFormat = Calendar.getDateMomentFormat();
    const timeFormat = Calendar.getTimeMomentFormat();

    if (requestTime.isValid()) {
      if (this.props.event.labels.YYYMMDD === requestTime.format('YYYY-MM-DD') && !this.props.event.overnight) {
        return requestTime.format(timeFormat);
      }
      return requestTime.format(dateFormat + ' @ ' + timeFormat);
    }
    return 'N/A';
  }

  render() {
    const { event, hideUndecidedChanges, push } = this.props;
    let description;
    let setupInstructions;
    let notes;

    if (!event || event.isLoading) {
      return (
        <Loading withWrapper />
      );
    }

    if (event && !event.isLoading && !event.labels) {
      return (
        <div className="centered" style={{ minHeight: 200 }}>
          <Link to="/calendar">View Calendar</Link>
        </div>
      );
    }

    const dateFormat = Calendar.getDateMomentFormat();
    const timeFormat = Calendar.getTimeMomentFormat();

    let loggedIn = false;

    const { authToken, userId } = auth.getAuthData();
    if (authToken && userId) {
      loggedIn = true;
    }

    if (event.description) {
      description = <div className="event-description" dangerouslySetInnerHTML={this.description} />;
    }
    if (event.setup_instructions) {
      setupInstructions = <div dangerouslySetInnerHTML={this.setupInstructions} />;
    }
    if (event.notes) {
      notes = <div dangerouslySetInnerHTML={this.notes} />;
    }

    let miscInfo = '';
    const miscInfoLines = [];

    if (has(event.metadata, 'payment_method') && event.metadata.payment_method && loggedIn) {
      miscInfoLines.push(
        <div className="flex-item-fill" key="payment_method">
          <h5>Payment Method</h5>
          <p>{event.metadata.payment_method.data}</p>
        </div>
      );
    }

    if (has(event, 'time_period_set') && event.time_period_set && loggedIn) {
      miscInfoLines.push(
        <div className="flex-item-fill" key="time_period_set">
          <h5>Time Period Set</h5>
          <p>{event.time_period_set.name}</p>
        </div>
      );
    }

    if (has(event, 'user_viewing_groups') && event.user_viewing_groups && event.user_viewing_groups.length > 0) {
      miscInfoLines.push(
        <div className="flex-item-fill" key="visible_to">
          <h5>Visible To</h5>
          {event.user_viewing_groups.map((uvg, key) => <p key={`uvg${uvg.id}`}>{uvg.name}</p>)}
        </div>
      );
    }

    if (event.type.id !== 5 && has(event, 'security') && event.security && event.security.length > 0) {
      miscInfoLines.push(
        <div className="flex-item-fill" key="owned_by">
          <h5>Owned By</h5>
          {event.security.map((pg, key) => <p key={`pg${pg.id}`}>{pg.name}</p>)}
        </div>
      );
    }

    if (has(event, 'request_user_id') && event.request_user_id && loggedIn) {
      miscInfoLines.push(
        <div className="flex-item-fill" key="created_by">
          <h5>Created By</h5>
          <p>{event.request_user_id.first_name} {event.request_user_id.last_name}</p>
        </div>
      );
      miscInfoLines.push(
        <div className="flex-item-fill" key="created_on">
          <h5>Created On</h5>
          <p>{moment(event.request_date).format('MMMM Do YYYY, ' + timeFormat)}</p>
        </div>
      );
    }

    if (has(event, 'modified') && event.modified && loggedIn) {
      miscInfoLines.push(
        <div className="flex-item-fill" key="last_modified">
          <h5>Last Modified</h5>
          <p>{moment(event.modified).format('MMMM Do YYYY, ' + timeFormat)}</p>
        </div>
      );
    }

    if (has(event, 'id') && event.id && loggedIn) {
      miscInfoLines.push(
        <div className="flex-item-fill" key="event_id">
          <h5>Event ID</h5>
          <p>{event.id}</p>
        </div>
      );
    }

    const billingEvents = [];
    let lineItems = '';
    let forms = '';

    if (event.type.id === 5) {
      if (event.billing_events && event.billing_events.length > 0) {
        let hasProcFee = false;
        each(event.billing_events, (bill) => {
          if (bill.type.id === 3) {
            hasProcFee = true;
          }

          const insert = {
            id: bill.id,
            type: bill.type.data,
            status: bill.status.data,
            amount: bill.amount,
            payment_method: bill.payment_method.data,
            invoice: '',
            invoice_id: '',
            has_proc_fee: hasProcFee,
          };

          const invoiceLink = {};
          const invoiceIdLink = {};

          if (bill.exported === 't' && bill.export_id) {
            invoiceLink.url = `type=batched_invoices&action=print_batch_invoice&id=${bill.export_id}`;
            invoiceLink.text = 'Batched PDF Invoice';

            invoiceIdLink.url = `type=batched_invoices&action=details&id=${bill.export_id}`;
            invoiceIdLink.text = `B-${bill.export_id}`;
          } else {
            invoiceLink.url = `type=facility_rental_bills&action=print_facility_billing_invoices&id=${bill.id}`;
            invoiceLink.text = 'PDF Invoice';

            invoiceIdLink.url = `type=facility_rental_bills&action=details&id=${bill.id}`;
            invoiceIdLink.text = bill.id;
          }

          if (bill.status.id < 2) {
            invoiceLink.url = null;
            invoiceLink.text = 'N/A';
          }

          insert.invoice = invoiceLink;
          insert.invoice_id = invoiceIdLink;

          billingEvents.push(insert);
        });
      }

      if (event.line_items_by_facility_id && isObject(event.line_items_by_facility_id)) {
        const lineItemsIn = [];
        let numLineItems = 0;

        each(event.line_items_by_facility_id, (lineItemByFacility, lineItemByFacilityId) => {
          const lineItemsFacilityTitle = (
            <div key={`line_item_facility_${lineItemByFacilityId}`} className="flex-container line-item-facility">
              <div className="flex-item-fill"><span dangerouslySetInnerHTML={{ __html: lineItemByFacility.name }} /></div>
            </div>
          );

          lineItemsIn.push(lineItemsFacilityTitle);

          each(lineItemByFacility.lineItems, (lineItem) => {
            const lineItemsFacilityDataPart = (
              <div key={`line_item_${lineItem.id}`} className="flex-container line-item-data">
                <div className="flex-item-fixed-200"><span dangerouslySetInnerHTML={{ __html: lineItem.name }} /></div>
                <div className="flex-item-fixed-100">{lineItem.cost}</div>
                <div className="flex-item-fixed-100">{lineItem.quantity}</div>
                <div className="flex-item-fixed-100">${lineItem.amount}</div>
              </div>
            );
            lineItemsIn.push(lineItemsFacilityDataPart);
            numLineItems += 1;
          });
        });

        if (numLineItems > 0) {
          lineItems = (
            <Collapsable
              iconName="line-item"
              title={numLineItems > 1 ? 'Line Items' : 'Line Item'}
              content={
                <div className="event-line-items">
                  <div key="line_item_headers" className="flex-container line-item-headers">
                    <div className="flex-item-fixed-200"><span className="advantage">Name</span></div>
                    <div className="flex-item-fixed-100"><span className="advantage">Cost</span></div>
                    <div className="flex-item-fixed-100"><span className="advantage">Quantity</span></div>
                    <div className="flex-item-fixed-100"><span className="advantage">Amount</span></div>
                  </div>
                  {lineItemsIn}
                </div>
              }
            />
          );
        }
      }

      if (event.forms_by_facility_id && isObject(event.forms_by_facility_id)) {
        const formsIn = [];
        let numForms = 0;

        each(event.forms_by_facility_id, (formByFacility, formByFacilityId) => {
          const formsFacilityTitle = (
            <div key={`form_facility_${formByFacilityId}`} className="flex-container form-facility">
              <div className="flex-item-fill"><span dangerouslySetInnerHTML={{ __html: formByFacility.name }} /></div>
            </div>
          );

          formsIn.push(formsFacilityTitle);

          each(formByFacility.forms, (form) => {
            const filledOutOut = (form.filled_out === 't' ? 'Yes' : 'No');
            const formsFacilityDataPart = (
              <div key={`form_${form.id}`} className="flex-container form-data">
                <div className="flex-item-fixed-200"><span dangerouslySetInnerHTML={{ __html: form.name }} /></div>
                <div className="flex-item-fixed-100">{filledOutOut}</div>
                <div className="flex-item-fixed-100">
                  {form.attachment_id !== null && (<a target="_blank" href={`${window.API_ROOT}?type=export&action=file&export_type=db_file&id=${form.attachment_id}`}>Download</a>)}
                </div>
              </div>
            );
            formsIn.push(formsFacilityDataPart);
            numForms += 1;
          });
        });

        if (numForms > 0) {
          forms = (
            <Collapsable
              iconName="form"
              title={numForms > 1 ? 'Forms' : 'Form'}
              content={
                <div className="event-forms">
                  <div key="form_headers" className="flex-container form-headers">
                    <div className="flex-item-fixed-200"><span className="advantage">Name</span></div>
                    <div className="flex-item-fixed-100"><span className="advantage">Filled Out</span></div>
                    <div className="flex-item-fixed-100"><span className="advantage">Download</span></div>
                  </div>
                  {formsIn}
                </div>
              }
            />
          );
        }
      }
    }

    let transportationRequests = '';

    if (event.transportation_requests && event.transportation_requests.length > 0) {
      const transportationRequestsIn = [];
      let numTransportationRequests = 0;

      each(event.transportation_requests, (request, key) => {
        const transportationRequestPart = (
          <div className="transportation-request-data" key={`transReq${key}`}>
            <div><h4>School</h4><p>{request.school_name}</p></div>
            <div><h4>Status</h4><p>{request.status_name}</p></div>
            {request.alert_name.length > 0 && request.status !== 1 && request.status !== 4 && (<div><h4>Alert</h4><p>{request.alert_name}</p></div>)}
            <div><h4>School Depart</h4><p>{this.transportationRequestTime(request.school_depart)}</p></div>
            <div><h4>Destination Arrival</h4><p>{this.transportationRequestTime(request.dest_arrival)}</p></div>
            <div><h4>Destination Depart</h4><p>{this.transportationRequestTime(request.dest_depart)}</p></div>
            <div><h4>Return Arrival</h4><p>{this.transportationRequestTime(request.return_arrival)}</p></div>
            <div><h4>Adults / Students</h4><p>{request.num_adults} / {request.num_students}</p></div>
            <div><h4>Wheelchair Slots / Storage Compartments</h4><p>{request.num_wheelchairs} / {request.num_compartments}</p></div>
            <div><h4>Notes</h4><p dangerouslySetInnerHTML={{ __html: request.notes }} /></div>
          </div>
        );
        transportationRequestsIn.push(transportationRequestPart);
        numTransportationRequests += 1;
      });

      if (numTransportationRequests > 0) {
        transportationRequests = (
          <Collapsable
            iconName="transportation-request"
            title={numTransportationRequests > 1 ? 'Transportation Requests' : 'Transportation Request'}
            content={
              <div className="event-transportation-requests">
                {transportationRequestsIn}
              </div>
            }
          />
        );
      }
    }

    let trips = '';

    if (event.trips && event.trips.length > 0) {
      const tripsIn = [];
      let numTrips = 0;

      each(event.trips, (trip) => {

        let tripDriver;
        let tripBus;
        let tripCharter;

        if(trip.driver) {
          tripDriver = (
            <div key={`driver:${trip.driver.id}`}>
              <h4>Driver</h4>
              <p key={`driver-details:${trip.driver.id}`}>
                <span dangerouslySetInnerHTML={{ __html: unescape(`${trip.driver.first_name} ${trip.driver.last_name}`) }} />
                {trip.driver.email && trip.driver.email.length > 0 && (<span className="advantage">email <a href={`mailto:${trip.driver.email}`}>{trip.driver.email}</a></span>)}
                {trip.driver.work_phone && trip.driver.work_phone.length > 0 && (<span className="advantage">phone <a href={`tel:${trip.driver.work_phone}`}>{trip.driver.work_phone}</a></span>)}
              </p>
            </div>
          );
        }

        if(trip.bus) {
          tripBus = (
            <div key={`vehicle:${trip.bus.id}`}>
              <h4>Vehicle</h4>
              <p key={`vehicle-details:${trip.bus.id}`}>
                <span dangerouslySetInnerHTML={{ __html: trip.bus.type.name }} /> <span dangerouslySetInnerHTML={{ __html: trip.bus.number }} />
              </p>
            </div>
          );
        }

        if(trip.charter) {
          tripCharter = (
            <div key={`charter:${trip.charter.id}`}>
              <h4>Charter</h4>
              <p key={`charter-details:${trip.charter.id}`}>
                <span dangerouslySetInnerHTML={{ __html: trip.charter.name }} />
              </p>
            </div>
          );
        }

        const tripPart = (
          <div className="trip-data" key={`trip-${trip.number}`}>
            <div><h4>Number</h4><p>{trip.number}</p></div>
            <div><h4>Type</h4><p>{trip.type_name}</p></div>
            {tripDriver}
            {tripBus}
            {tripCharter}
            {trip.type !== 3 && (
              <div className="time-location">
                <h4>Going Depart & Pickup</h4>
                <p>{this.transportationRequestTime(trip.going_depart)}</p>
                {trip.going_pickup.map((tripLoc, key) => <p key={`tgp${key}`}>{tripLoc}</p>)}
              </div>
            )}
            {trip.type !== 3 && (
              <div className="time-location">
                <h4>Going Arrival & Dropoff</h4>
                <p>{this.transportationRequestTime(trip.going_arrival)}</p>
                {trip.going_dropoff.map((tripLoc, key) => <p key={`tgd${key}`}>{tripLoc}</p>)}
              </div>
            )}
            {trip.type !== 2 && (
              <div className="time-location">
                <h4>Return Depart & Pickup</h4>
                <p>{this.transportationRequestTime(trip.return_depart)}</p>
                {trip.return_pickup.map((tripLoc, key) => <p key={`trp${key}`}>{tripLoc}</p>)}
              </div>
            )}
            {trip.type !== 2 && (
              <div className="time-location">
                <h4>Return Arrival & Dropoff</h4>
                <p>{this.transportationRequestTime(trip.return_arrival)}</p>
                {trip.return_dropoff.map((tripLoc, key) => <p key={`trd${key}`}>{tripLoc}</p>)}
              </div>
            )}
          </div>
        );
        tripsIn.push(tripPart);
        numTrips += 1;
      });

      if (numTrips > 0) {
        trips = (
          <Collapsable
            iconName="trip"
            title={numTrips > 1 ? 'Trips' : 'Trip'}
            content={
              <div className="event-trips">
                {tripsIn}
              </div>
            }
          />
        );
      }
    }

    if(!event.time_leave && !event.time_return && has(event.metadata, 'simple_trips') && event.metadata.simple_trips) {
      if(event.metadata.simple_trips.length === 1) {
        let numSchools = 0;
        let onlySchoolID = null;

        if (event.participants && isObject(event.participants)) {
          each(event.participants, (eventParticipant) => {
            if(eventParticipant.type == 'school') {
              numSchools++;
              onlySchoolID = eventParticipant.id;
            }
          });
        }

        if (event.tags && isObject(event.tags)) {
          each(event.tags, (eventTag) => {
            if(eventTag.type == 'school') {
              numSchools++;
              onlySchoolID = eventTag.id;
            }
          });
        }

        if(numSchools == 1) {

          if(event.metadata.simple_trips[0].locations == 's_' + onlySchoolID) {

            if(event.metadata.simple_trips[0].depart.length > 0) {
              event.time_leave = event.metadata.simple_trips[0].depart[0];
              event.time_leave = moment(event.time_leave).format(timeFormat);
            }

            if(event.metadata.simple_trips[0].return.length > 0) {
              event.time_return = event.metadata.simple_trips[0].return[0];
              event.time_return = moment(event.time_return).format(timeFormat);
            }
          }
        }
      }
    }

    const changesToShow = [];
    const approvalData = [];
    let approvalButtons;
    let editDisplayType = 'primary';

    let request_description_out = false;

    if (has(event, 'changes') && event.changes.length) {
      event.changes.forEach((change) => {
        if ((hideUndecidedChanges && change.have_undecided_roles) || !hideUndecidedChanges) {
          changesToShow.push(change);
        }
      });

      if (changesToShow.length === 1 && event.status.id === 5) {
        const change = changesToShow.pop();

        approvalData.push = (
          <div className="flex-container" key="requested_by_on">
            <div className="flex-item-fixed-30"><Icon size="large" icon="contact" /></div>
            <div className="flex-item-fill">
              <h4>Requested By/On</h4>
              <p>{change.change_user_id.first_name} {change.change_user_id.last_name}</p>
              <p>{moment(change.change_performed).format('MMMM Do YYYY, ' + timeFormat)}</p>
            </div>
          </div>
        );

        if(has(event, 'request_description') && event.request_description) {
          request_description_out = true;
          approvalData.push = (
              <div className="flex-container" key="request_description">
                <div className="flex-item-fixed-30"><Icon size="large" icon="notes" /></div>
                <h4>Request Description</h4>
                <div className="flex-item-fill">{event.request_description}</div>
              </div>
          );
        }

        approvalButtons = <ActionButtonRow change={change} event={event} onConflicts={(conflicts) => { this.setState({ conflicts }); }} />;

        editDisplayType = '';
      }
    }

    if(!request_description_out && has(event, 'request_description') && event.request_description) {
      request_description_out = true;
      miscInfoLines.push = (
        <div className="flex-container" key="request_description">
          <h5>Request Description</h5>
          <div className="flex-item-fill">{event.request_description}</div>
        </div>
      );
    }

    const doClickAction = (action, event) => {
      let href = `type=event&action=${action.action_type}&id=${this.props.event.id}&send_event_emails=1&json=t${action.url_extra}`;

      // if (reason) {
      //   href += `&reason=${encodeURIComponent(reason)}`;
      // }

      const target = event.currentTarget;
      if (!target.classList.contains('loading')) {
        target.classList.add('loading');

        apiFetch(`${API_ROOT}?${href}`, true).then((response) => {
          if (response.error === true || response.error === 1 || response.error === '1') {
            target.classList.remove('loading');
            this.props.setFlashMessage((
              <span>
                {action.text} Error
                {response.error_msgs.map((e, i) => (<span key={i}><br /><span>- {e}</span></span>))}
              </span>
            ), 'error');
          } else {
            let message = `This event has been ${action.success_text.toLowerCase()}.`;
            this.props.setFlashMessage(message);

            // Give it a second to set in that we finished performing the action
            // and then redirect to main inbox page
            setTimeout(() => {
              target.classList.remove('loading');
              this.props.loadEvent(this.props.event.id);
            }, 1000);

            // Clear the flashMessage after some ammount of time the 'feels right' (4500ms)
            setTimeout(() => {
              this.props.removeFlashMessage(message);
            }, 4500);
          }
        }, () => {
          target.classList.remove('loading');
        });
      }
    };

    let actionButtonsData = [];
    let actionButtons;

    if (has(event, 'metadata.actions.admin') && event.type) {
      if ((event.type.id === 1 || event.type.id === 6) && !event.do_not_show_edit && findIndex(event.metadata.actions.admin, check => check.text === 'Edit') !== -1) {
        actionButtonsData.push({
          link: `/calendar/edit/${event.id}`,
          text: 'Edit',
          display_type: editDisplayType,
          url_extra: '',
        });
      }

      if (event.type.id === 1 || event.type.id === 5 || event.type.id === 6) {
        if (findIndex(event.metadata.actions.admin, check => check.text === 'Unlock') !== -1) {
          actionButtonsData.push({
            text: 'Unlock',
            success_text: 'Unlocked',
            display_type: 'attention',
            action_type: 'trans_unlock',
            url_extra: '&page=2',
          });
        }

        if (findIndex(event.metadata.actions.admin, check => check.text === 'Cancel') !== -1) {
          actionButtonsData.push({
            text: 'Cancel',
            success_text: 'Canceled',
            display_type: 'attention',
            action_type: 'cancel_event',
            url_extra: '',
          });
        }

        if (findIndex(event.metadata.actions.admin, check => check.text === 'Reinstate') !== -1) {
          actionButtonsData.push({
            text: 'Reinstate',
            success_text: 'Reinstated',
            display_type: 'approve',
            action_type: 'reinstate_event',
            url_extra: '&override_conflicts=1',
          });
        }

        if (findIndex(event.metadata.actions.admin, check => check.text === 'Approve') !== -1) {
          actionButtonsData.push({
            text: 'Approve',
            success_text: 'Approved',
            display_type: 'approve',
            action_type: 'approval',
            url_extra: '&override_conflicts=1',
          });
        }

        // if (has(event, 'metadata.actions.other')) {
        //   if (findIndex(event.metadata.actions.other, check => check.text === 'Delete') !== -1) {
        //     actionButtonsData.push({
        //       text: 'Delete',
        //       success_text: 'Deleted',
        //       display_type: 'decline',
        //       action_type: 'delete_event',
        //       url_extra: '&delete_from_other_calendars=1',
        //     });
        //   }
        // }
      }

      actionButtons = (
        <div>
          <section className="button-row">
            {actionButtonsData.map((action, index) => {
              const handleClick = (clickAction, event) => {

                if (clickAction.text === 'Edit') {
                  this.props.push(`/calendar/edit/${this.props.event.id}`);
                  return;
                }

                if (confirm(`Click OK below to ${action.text.toLowerCase()} this event.`)) {
                  doClickAction(action, event);
                }
              };
              return (
                <button
                  onClick={(event) => { handleClick(action, event); }}
                  className={action.display_type}
                  key={`${event.id}_${action.text}_${index}`}
                  style={{ position: 'relative' }}
                >
                  <Loading
                    className="button-loading"
                    size="small"
                    color="white"
                    style={{
                      position: 'absolute',
                      top: 9,
                      left: 6,
                    }}
                  />
                  {action.text}
                </button>
              );
            })}
          </section>
        </div>
      );
    } else {
      let addToMyCalendarUrl = `${API_ROOT}?type=export&action=ical&id=${this.props.event.id}`;
      addToMyCalendarUrl = auth.getAuthURL(addToMyCalendarUrl);

      actionButtons = (
        <div style={{ marginTop: 24 }}>
          <section className="button-row">
            <button
              className="primary"
              key={`${event.id}_addtomycalendar`}
              style={{ position: 'relative' }}
            >
              <a
                href={`${unescape(addToMyCalendarUrl)}`}
                style={{ color: 'inherit' }}
              >
                <Icon
                  icon="calendar"
                  size="medium"
                  style={{
                    marginTop: -3,
                    marginRight: 8,
                    display: 'inline-block',
                  }}
                />
                Add to my calendar
              </a>
            </button>
          </section>
        </div>
      );
    }

    const statusOut = [];

    if (event.status.id === 2 || event.status.id === 6) {

      if(event.ghost == 't') {
        statusOut.push(<span key="canceled" className="cancelled">Rescheduled to <Link to={`/calendar/details/${event.ghost_parent.id}`}>{event.ghost_parent.date_start}</Link></span>);
      } else {
        statusOut.push(<span key="canceled" className="cancelled">Cancelled</span>);
      }
    } else if (event.status.id === 3) {
      statusOut.push(<span key="tentative" className="tentative">Tentative</span>);
    } else if (event.status.id === 5) {
      statusOut.push(<span key="awaiting" className="awaiting-approval">Awaiting Approval</span>);
    } else if (event.status.id === 7) {
      statusOut.push(<span key="canceled" className="cancelled">Declined</span>);
    }

    if (event.user_viewing_groups && event.user_viewing_groups.length > 0) {
      statusOut.push(<span key="private" className="private">Private</span>);
    }

    let mapAddress;
    if (event.locations.length > 0) {
      for (const l of event.locations) {
        if (has(l, 'address.address') && l.address.address && has(l, 'address.city') && l.address.city && has(l, 'address.zip') && l.address.zip) {
          mapAddress = `${l.address.address}, ${l.address.city}, ${l.address.zip}`;
          break;
        } else if (has(l, 'school.address') && l.school.address && has(l, 'school.city') && l.school.city && has(l, 'school.zip') && l.school.zip) {
          mapAddress = `${l.school.address}, ${l.school.city}, ${l.school.zip}`;
          break;
        }
      }
    }
    const mapBackgroundStyle = {};
    if (mapAddress) {
      mapBackgroundStyle.backgroundImage = `url('https://maps.googleapis.com/maps/api/staticmap?center=${mapAddress}&zoom=13&size=600x300&maptype=roadmap&markers=color:red%7Clabel:%7C${mapAddress}&key=${window.GOOGLE_MAPS_API_KEY}')`;
      mapBackgroundStyle.backgroundPositionX = 'center';
      mapBackgroundStyle.backgroundPositionY = 'center';
    }

    let titleSection = <h2 className="list-header"><span dangerouslySetInnerHTML={{ __html: event.name }} /></h2>;

    let mapSection;

    if (mapAddress) {
      mapSection = (
        <div>
          <div
            className="event-map-background"
            style={mapBackgroundStyle}
          >
          </div>
          <div className="flex-container event-map-directions">
            <div className="flex-item-fill">
              <a target="_blank" href={`https://maps.google.com?q=${mapAddress}`}>Get Directions</a>
            </div>
          </div>
        </div>
      );

          // onClick={() => {
          //   window.open(`https://maps.google.com?q=${mapAddress}`, '_blank');
          // }}
    }

    const featuredImageBackgroundStyle = {};

    if (event.featured_image && event.featured_image.id.length > 0) {
      featuredImageBackgroundStyle.backgroundImage = `url('${window.API_ROOT}?type=export&action=image&export_type=db_thumb&id=${event.featured_image.id}')`;
      featuredImageBackgroundStyle.backgroundPositionX = 'center';
      featuredImageBackgroundStyle.backgroundPositionY = 'center';

      //<a target="_blank" href={`${window.API_ROOT}?type=export&action=image&export_type=db_image&id=${event.featured_image.id}`}></a>
    }

    let virtualMeetingLink;

    if (has(event, 'virtual_meeting_link') && event.virtual_meeting_link) {
      virtualMeetingLink = (
        <div key="virtual_meeting_link" className="flex-container">
          <div className="flex-item-fixed-30"><Icon size="large" icon="share" /></div>
          <div className="flex-item-fill">
            <h4>Virtual Meeting Link</h4>
            <a href={event.virtual_meeting_link}>{event.virtual_meeting_link}</a>
          </div>
        </div>
      );
    }

    let eventBubbleOut;

    if(event.type.id !== 2 && event.type.id !== 3 && event.type.id !== 4) {
      eventBubbleOut = (
        <EventBubble key="event_bubble_object" event={event} />
      );
    }

    if(event.time_leave && !event.time_return) {
      event.time_return = '??';
    } else if(!event.time_leave && event.time_return) {
      event.time_leave = '??';
    }

    let timezoneOut;
    let miscTimeZoneOut;

    if (has(event.metadata, 'to_timezone_data')) {
      let tzid_abbrev = event.metadata.to_timezone_data.tzid_abbrev;

      if(event.metadata.to_timezone_data.offset > 0) event.metadata.to_timezone_data.offset = '+' + event.metadata.to_timezone_data.offset;

      let timezone_tooltip = event.metadata.to_timezone_data.data;
      // timezone_tooltip += '|br|' + event.metadata.to_timezone_data.tzid;
      timezone_tooltip += ' (UTC ' + event.metadata.to_timezone_data.offset + ')';

      if(has(event.metadata, 'event_timezone_data')) {
        tzid_abbrev += '*';

        if(event.metadata.event_timezone_data.offset > 0) event.metadata.event_timezone_data.offset = '+' + event.metadata.event_timezone_data.offset;

        timezone_tooltip += '<br />' + 'This event has been adjusted to show in your timezone.  It is currently scheduled in ' + event.metadata.event_timezone_data.tzid_abbrev + ' (UTC ' + event.metadata.event_timezone_data.offset + ').';
      }

      timezoneOut = (<div><h4><span className="parent">{tzid_abbrev}</span></h4></div>);

      miscInfoLines.push(
        <div className="flex-item-fill" key="timezone_extra">
          <h5>TimeZone Info</h5>
          <p dangerouslySetInnerHTML={{ __html: timezone_tooltip }} />
        </div>
      );

    } else if(has(event.metadata, 'event_timezone_data')) {

      if(event.metadata.event_timezone_data.offset > 0) event.metadata.event_timezone_data.offset = '+' + event.metadata.event_timezone_data.offset;

      let timezone_tooltip = event.metadata.event_timezone_data.data;
      // timezone_tooltip += '|br|' + event.metadata.event_timezone_data.tzid;
      timezone_tooltip += ' (UTC ' + event.metadata.event_timezone_data.offset + ')';

      timezoneOut = (<div><h4><span className="parent">{event.metadata.event_timezone_data.tzid_abbrev}</span></h4></div>);

      miscInfoLines.push(
        <div className="flex-item-fill" key="timezone_extra">
          <h5>TimeZone Info</h5>
          <p dangerouslySetInnerHTML={{ __html: timezone_tooltip }} />
        </div>
      );
    }

    if(miscInfoLines.length > 0) {
      miscInfo = (
        <Collapsable
          iconName="list"
          title="Misc Info"
          content={
            <div className="event-misc-info">
              {miscInfoLines}
            </div>
          }
        />
      );
    }

    return (
      <section className="event-detail">
        <div className="event-detail-view">

          {event.featured_image && event.featured_image.id.length > 0 && (
            <div>
              <div className="event-featured-image-background" style={featuredImageBackgroundStyle}>
              </div>
            </div>
          )}

          {titleSection}
          {statusOut.length > 0 && (<div className="event-status">{statusOut}</div>)}
          {event.description && (description)}

          <div className="flex-container date-and-time">
            <div className="flex-item-fixed-30"><Icon size="large" icon="calendar" /></div>
            <div className="flex-item-fill">
              {event.overnight && event.labels.start_time !== 'All Day' && (
                <div>
                  <h4>{event.labels.start_moment.format('dddd, MMM D, YYYY')} - {event.labels.start_time} to </h4>
                  <h4>{event.labels.end_moment.format('dddd, MMM D, YYYY')} - {event.labels.end_time}</h4>
                </div>
              )}
              {event.overnight && event.labels.start_time === 'All Day' && (
                <div>
                  <h4>{event.labels.start_moment.format('dddd, MMM D, YYYY')} to </h4>
                  <h4>{event.labels.end_moment.format('dddd, MMM D, YYYY')}</h4>
                </div>
              )}
              {!event.overnight && (
                <div>
                  <h4>{event.labels.start_moment.format('dddd, MMM D, YYYY')}</h4>
                  <h4>{event.labels.time_duration}</h4>
                </div>
              )}
              {event.time_setup && event.time_breakdown && (
                <h3>Setup {event.time_setup} - Breakdown {event.time_breakdown}</h3>
              )}
              {event.time_leave && event.time_return && (
                <h3>Depart {event.time_leave} - Return {event.time_return}</h3>
              )}
              {event.time_dismiss && (
                <h3>Early Dismissal {event.time_dismiss}</h3>
              )}
              {timezoneOut}
              {event.recurrence_desc_short.length > 0 && (
                <h3>{event.recurrence_desc_short}</h3>
              )}
            </div>
          </div>

          {virtualMeetingLink}

          {event.locations.length > 0 && (
            <Collapsable
              defaultOpen
              iconName="location"
              title={event.locations.length > 1 ? 'Locations' : 'Location'}
              content={event.locations.map(location => (
                <p key={location.id} dangerouslySetInnerHTML={{ __html: location.name }} />
              ))}
            />
          )}

          {event.participants.length > 0 && (
            <Collapsable
              defaultOpen
              iconName="groups"
              title={event.participants.length > 1 ? 'Participants' : 'Participant'}
              content={event.participants.map(participant => (
                <p key={`${participant.type}${participant.id}`}>
                  <span dangerouslySetInnerHTML={{ __html: participant.name }} />
                  {event.show_advantage && participant.advantage.length > 0 && (<span className="advantage">({participant.advantage})</span>)}
                </p>
              ))}
            />
          )}

          {event.equipment.length > 0 && (
            <Collapsable
              defaultOpen
              iconName="equipment"
              title="Equipment"
              content={event.equipment.map(equipment => (
                <p key={equipment.id}>
                  <span dangerouslySetInnerHTML={{ __html: equipment.name }} />
                  {equipment.total_quantity > 0 && (<span className="advantage">({equipment.used_quantity} of {equipment.total_quantity})</span>)}
                </p>
              ))}
            />
          )}

          {event.contacts.length > 0 && (
            <Collapsable
              defaultOpen
              iconName="my-profile"
              title={event.contacts.length > 1 ? 'Contacts' : 'Contact'}
              content={event.contacts.map(contact => (
                <p key={contact.id}>
                  <span dangerouslySetInnerHTML={{ __html: contact.name }} />
                  {contact.email && contact.email.length > 0 && (<span className="advantage">email <a href={`mailto:${contact.email}`}>{contact.email}</a></span>)}
                  {contact.work_phone && contact.work_phone.length > 0 && (<span className="advantage">phone <a href={`tel:${contact.work_phone}`}>{contact.work_phone}</a></span>)}
                </p>
              ))}
            />
          )}

          {event.supervisors.length > 0 && (
            <Collapsable
              defaultOpen
              iconName="my-profile"
              title={event.supervisors.length > 1 ? 'Supervisors' : 'Supervisor'}
              content={event.supervisors.map(supervisor => (
                <p key={supervisor.id}>
                  <span dangerouslySetInnerHTML={{ __html: supervisor.name }} />
                  {supervisor.email && supervisor.email.length > 0 && (<span className="advantage">email <a href={`mailto:${supervisor.email}`}>{supervisor.email}</a></span>)}
                  {supervisor.work_phone && supervisor.work_phone.length > 0 && (<span className="advantage">phone <a href={`tel:${supervisor.work_phone}`}>{supervisor.work_phone}</a></span>)}
                </p>
              ))}
            />
          )}

          {event.num_attending.length > 0 && (
            <div className="flex-container">
              <div className="flex-item-fixed-30"><Icon size="large" icon="contact" /></div>
              <div className="flex-item-fill">
                <h4>People Attending</h4>
                <p>{event.num_attending}</p>
              </div>
            </div>
          )}

          {event.type.id === 5 && event.total_cost && (
            <div className="flex-container">
              <div className="flex-item-fixed-30"><Icon size="large" icon="cost" /></div>
              <div className="flex-item-fill">
                <h4>Total Cost</h4>
                <p key="total_cost">${event.total_cost.toFixed(2)}</p>
              </div>
            </div>
          )}

          {event.type.id === 5 && billingEvents.length > 0 && (
            <Collapsable
              iconName="bill"
              title={billingEvents.length > 1 ? 'Bills' : 'Bill'}
              content={
                <div className="event-bills">
                  <div key="bill_headers" className="flex-container bill-headers">
                    <div className="flex-item-fixed-100"><span className="advantage">Type</span></div>
                    <div className="flex-item-fixed-100"><span className="advantage">Status</span></div>
                    <div className="flex-item-fixed-100"><span className="advantage">Amount</span></div>
                    <div className="flex-item-fixed-100"><span className="advantage">Invoice</span></div>
                  </div>
                  {billingEvents.map(bill => (
                    <div key={bill.id} className="flex-container bill-data">
                      <div className="flex-item-fixed-100">{bill.type}</div>
                      <div className="flex-item-fixed-100">{bill.status}</div>
                      <div className="flex-item-fixed-100">${bill.amount}</div>
                      <div className="flex-item-fixed-100">
                        {bill.invoice.url && (
                          <a target="_blank" href={`${window.API_ROOT}?${bill.invoice.url}`}>
                            {bill.invoice.text}
                          </a>
                        )}
                        {!bill.invoice.url && (
                          <span>{bill.invoice.text}</span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              }
            />
          )}

          {lineItems}
          {forms}

          {event.notes && (
            <Collapsable
              defaultOpen
              iconName="edit"
              title="Notes"
              content={notes}
            />
          )}

          {event.setup_instructions && (
            <Collapsable
              defaultOpen
              iconName="edit"
              title="Setup Instructions"
              content={setupInstructions}
            />
          )}

          {event.setup_picture && event.setup_picture.id.length > 0 && (
            <div className="flex-container">
              <div className="flex-item-fixed-30"><Icon size="large" icon="image" /></div>
              <div className="flex-item-fill">
                <h4>Setup Image</h4>
                <a target="_blank" href={`${window.API_ROOT}?type=export&action=image&export_type=db_image&id=${event.setup_picture.id}`}>
                  <img src={`${window.API_ROOT}?type=export&action=image&export_type=db_thumb&id=${event.setup_picture.id}`} />
                </a>
              </div>
            </div>
          )}

          {event.attachments && event.attachments.length > 0 && (
            <Collapsable
              iconName="attach"
              title={event.attachments.length > 1 ? 'Attachments' : 'Attachment'}
              content={(
                <ul>
                  {event.attachments.map(attachment => (
                    <li key={attachment.id}>
                      <a target="_blank" href={`${window.API_ROOT}?type=export&action=file&id=${attachment.id}`}>
                        <span dangerouslySetInnerHTML={{ __html: attachment.name }} />
                        {`.${attachment.extension}`}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            />
          )}

          {event.request_attachments && event.request_attachments.length > 0 && (
            <Collapsable
              iconName="attach"
              title={event.request_attachments.length > 1 ? 'Private Attachments' : 'Private Attachment'}
              content={(
                <ul>
                  {event.request_attachments.map(attachment => (
                    <li key={attachment.id}>
                      <a target="_blank" href={`${window.API_ROOT}?type=export&action=file&id=${attachment.id}`}>
                        <span dangerouslySetInnerHTML={{ __html: attachment.name }} />
                        {`.${attachment.extension}`}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            />
          )}

          {transportationRequests}
          {trips}

          {event.tags.length > 0 && (
            <Collapsable
              iconName="tag"
              title={event.tags.length > 1 ? 'Tags' : 'Tag'}
              content={event.tags.map(tag => (
                <p key={`${tag.type}${tag.id}`}>
                  <span dangerouslySetInnerHTML={{ __html: tag.name }} />
                  {event.show_advantage && tag.advantage.length > 0 && (<span className="advantage">({tag.advantage})</span>)}
                </p>
              ))}
            />
          )}

          {miscInfo}

          {event.conflicts && (
            <Collapsable
              iconName="conflicts"
              title="Conflicts"
              defaultOpen={!includes([1, 2, 3], event.status.id)}
              content={event.conflicts.map((conflict, i) => (
                <div key={`conflict${i}`}>
                  <h3>{conflict.title} ({conflict.num_conflicts})</h3>
                  <ul>
                    {conflict.objects && conflict.objects.map((item, item_key) => (
                      <li key={`conflictItem${conflict.title}${item_key}`}>
                        <span dangerouslySetInnerHTML={{ __html: item.name }} />
                        {item.conflict_quantity && (
                          <div className="conflict-context" key={`conflictConflictQuantity${conflict.title}${item_key}`}>
                            <span dangerouslySetInnerHTML={{ __html: item.conflict_quantity }} />
                          </div>
                        )}
                        {item.conflict_range && (
                          <div className="conflict-context" key={`conflictConflictRange${conflict.title}${item_key}`}>
                            <span dangerouslySetInnerHTML={{ __html: item.conflict_range }} /><br />
                          </div>
                        )}
                        {item.conflict_quantity && item.events && item.events.map(eventConflict => (
                          <div className="conflict-context" key={`conflictEventContext${conflict.title}${item_key}${eventConflict.id}`}>
                            Event: <span dangerouslySetInnerHTML={{ __html: eventConflict.name }} />
                          </div>
                        ))}
                        {!item.conflict_quantity && item.events && item.events.map(eventConflict => (
                          <div className="conflict-context" key={`conflictEventContext${conflict.title}${item_key}${eventConflict.id}`}>
                            Event: <span dangerouslySetInnerHTML={{ __html: eventConflict.name }} /> {eventConflict.conflict_range}
                          </div>
                        ))}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            />
          )}

          {mapSection}

          {eventBubbleOut}

          {approvalData}
          {approvalButtons}
          {actionButtons}

        </div>

        {changesToShow.length > 0 && (
          <section className="event-detail inbox-changes">
            <div className="event-detail-view">
              <h2 className="list-header">Changes</h2>
              {changesToShow.map((change, index) => (
                <div key={`${change.change_id}_${index}`}>
                  <p dangerouslySetInnerHTML={{ __html: change.changes }} />
                  {change.conflicts && (<OverrideConflicts conflicts={change.conflicts} event={event} />)}
                  <p>
                    <small>
                      Requested By: {change.change_user_id.first_name} {change.change_user_id.last_name}<br />
                      Requested At: {moment(change.change_performed).format('MMMM Do YYYY, ' + timeFormat)}
                    </small>
                  </p>

                  <ActionButtonRow change={change} event={event} onConflicts={(conflicts) => { this.setState({ conflicts }); }} />
                </div>
              ))}
            </div>
          </section>
        )}
      </section>
    );
  }
}

function mapStateToProps(/* state */) {
  // const { inbox } = state;
  // const { events, isLoading } = inbox;

  return {
    // isLoading,
    // events,
  };
}

export default connect(mapStateToProps, {
  setFlashMessage,
  removeFlashMessage,
  push,
  loadEvent,
})(EventDetails);



// WEBPACK FOOTER //
// ./src/app/components/calendar/EventDetails.js